import {
  Person as PersonIcon,
  Security as SecurityIcon,
  Timeline as TimelineIcon,
  TrendingUp as TrendingUpIcon,
} from '@mui/icons-material';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import type React from 'react';
import type { ActivityData } from './types';

interface StatsCardsProps {
  data: ActivityData;
}

export const StatsCards: React.FC<StatsCardsProps> = ({ data }) => {
  if (!data.summary) {
    return null;
  }

  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <TimelineIcon color="primary" />
              <Box>
                <Typography variant="h6">{data.summary.totalActivities}</Typography>
                <Typography variant="body2" color="text.primary">
                  Total Activities
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <PersonIcon color="success" />
              <Box>
                <Typography variant="h6">{data.summary.uniqueUsers}</Typography>
                <Typography variant="body2" color="text.primary">
                  Active Users
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      {data.loginAnalytics && (
        <>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <SecurityIcon color="info" />
                  <Box>
                    <Typography variant="h6">{data.loginAnalytics.totalLogins}</Typography>
                    <Typography variant="body2" color="text.primary">
                      Total Logins
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <TrendingUpIcon color="warning" />
                  <Box>
                    <Typography variant="h6">{data.loginAnalytics.uniqueUsers}</Typography>
                    <Typography variant="body2" color="text.primary">
                      Unique Login Users
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </>
      )}
    </Grid>
  );
};
